import { invokeApi } from "../../bl_libs/invokeApi";

const getAuthHeader = () => ({
  "x-sh-auth": localStorage.getItem("token"),
});

// ============ XAIR SUPER ADMIN (GOD MODE) ============

export const get_all_schools_api = async (page = 1, limit = 50) => {
  const requestObj = {
    path: `api/school/get_all_schools`,
    method: "GET",
    headers: getAuthHeader(),
    queryParams: { page, limit },
  };
  return invokeApi(requestObj);
};

export const add_school_api = async (formData) => {
  const requestObj = {
    path: `api/school/add_school`,
    method: "POST",
    headers: getAuthHeader(),
    postData: formData,
  };
  return invokeApi(requestObj);
};

export const suspend_school_api = async (school_id, reason) => {
  const requestObj = {
    path: `api/school/${school_id}/suspend`,
    method: "POST",
    headers: getAuthHeader(),
    postData: { reason },
  };
  return invokeApi(requestObj);
};

export const terminate_school_api = async (school_id, reason) => {
  const requestObj = {
    path: `api/school/${school_id}/terminate`,
    method: "POST",
    headers: getAuthHeader(),
    postData: { reason },
  };
  return invokeApi(requestObj);
};

export const act_as_admin_api = async (school_id) => {
  const requestObj = {
    path: `api/school/act_as_admin/${school_id}`,
    method: "POST",
    headers: getAuthHeader(),
  };
  return invokeApi(requestObj);
};

export const get_all_audit_logs_api = async (page = 1, limit = 50) => {
  const requestObj = {
    path: `api/school/audit-logs/all`,
    method: "GET",
    headers: getAuthHeader(),
    queryParams: { page, limit },
  };
  return invokeApi(requestObj);
};

// ============ SCHOOL ADMIN - SCHOOL MANAGEMENT ============

export const get_school_api = async (school_id) => {
  const requestObj = {
    path: `api/school/get_school/${school_id}`,
    method: "GET",
    headers: getAuthHeader(),
  };
  return invokeApi(requestObj);
};

export const update_school_api = async (school_id, data) => {
  const requestObj = {
    path: `api/school/${school_id}`,
    method: "PUT",
    headers: getAuthHeader(),
    postData: data,
  };
  return invokeApi(requestObj);
};

export const upload_logo_api = async (school_id, formData) => {
  const requestObj = {
    path: `api/school/${school_id}/logo`,
    method: "POST",
    headers: getAuthHeader(),
    postData: formData,
  };
  return invokeApi(requestObj);
};

export const upload_favicon_api = async (school_id, formData) => {
  const requestObj = {
    path: `api/school/${school_id}/favicon`,
    method: "POST",
    headers: getAuthHeader(),
    postData: formData,
  };
  return invokeApi(requestObj);
};

// ============ SCHOOL ADMIN - STUDENT MANAGEMENT ============

export const get_students_api = async (school_id, page = 1, limit = 50, search = "") => {
  const requestObj = {
    path: `api/school/${school_id}/students`,
    method: "GET",
    headers: getAuthHeader(),
    queryParams: { page, limit, search },
  };
  return invokeApi(requestObj);
};

export const get_student_api = async (school_id, student_id) => {
  const requestObj = {
    path: `api/school/students/${student_id}`,
    method: "GET",
    headers: getAuthHeader(),
  };
  return invokeApi(requestObj);
};

export const add_student_api = async (school_id, data) => {
  const requestObj = {
    path: `api/school/${school_id}/students`,
    method: "POST",
    headers: getAuthHeader(),
    postData: data,
  };
  return invokeApi(requestObj);
};

export const update_student_api = async (school_id, student_id, data) => {
  const requestObj = {
    path: `api/school/students/${student_id}/profile`,
    method: "PUT",
    headers: getAuthHeader(),
    postData: data,
  };
  return invokeApi(requestObj);
};

export const renew_student_api = async (school_id, student_id, data) => {
  const requestObj = {
    path: `api/school/${school_id}/students/${student_id}/renew`,
    method: "PUT",
    headers: getAuthHeader(),
    postData: data,
  };
  return invokeApi(requestObj);
};

export const suspend_student_api = async (school_id, student_id, reason) => {
  const requestObj = {
    path: `api/school/${school_id}/students/${student_id}/suspend`,
    method: "PUT",
    headers: getAuthHeader(),
    postData: { reason },
  };
  return invokeApi(requestObj);
};

export const terminate_student_api = async (school_id, student_id, reason) => {
  const requestObj = {
    path: `api/school/${school_id}/students/${student_id}/terminate`,
    method: "PUT",
    headers: getAuthHeader(),
    postData: { reason },
  };
  return invokeApi(requestObj);
};

export const accept_invite_api = async (data) => {
  const requestObj = {
    path: `api/school/students/accept-invite`,
    method: "POST",
    headers: getAuthHeader(),
    postData: data,
  };
  return invokeApi(requestObj);
};

export const student_login_api = async (data) => {
  const requestObj = {
    path: `api/school/students/login`,
    method: "POST",
    postData: data,
  };
  return invokeApi(requestObj);
};

export const student_dashboard_api = async () => {
  const requestObj = {
    path: `api/school/students/dashboard`,
    method: "GET",
    headers: getAuthHeader(),
  };
  return invokeApi(requestObj);
};

// ============ SCHOOL ADMIN - ADMIN MANAGEMENT ============

export const get_admins_api = async (school_id) => {
  const requestObj = {
    path: `api/school/${school_id}/admins`,
    method: "GET",
    headers: getAuthHeader(),
  };
  return invokeApi(requestObj);
};

export const add_admin_api = async (school_id, data) => {
  const requestObj = {
    path: `api/school/${school_id}/admins`,
    method: "POST",
    headers: getAuthHeader(),
    postData: data,
  };
  return invokeApi(requestObj);
};

export const update_admin_api = async (school_id, admin_id, data) => {
  const requestObj = {
    path: `api/school/${school_id}/admins/${admin_id}/permissions`,
    method: "PUT",
    headers: getAuthHeader(),
    postData: data,
  };
  return invokeApi(requestObj);
};

export const remove_admin_api = async (school_id, admin_id) => {
  const requestObj = {
    path: `api/school/${school_id}/admins/${admin_id}`,
    method: "DELETE",
    headers: getAuthHeader(),
  };
  return invokeApi(requestObj);
};

// ============ SCHOOL ADMIN - AUDIT LOGS ============

export const get_school_audit_logs_api = async (school_id, page = 1, limit = 50) => {
  const requestObj = {
    path: `api/school/${school_id}/audit-logs`,
    method: "GET",
    headers: getAuthHeader(),
    queryParams: { page, limit },
  };
  return invokeApi(requestObj);
};

export const delete_school_api = async (school_id) => {
  const requestObj = {
    path: `api/school/${school_id}`,
    method: "DELETE",
    headers: getAuthHeader(),
  };
  return invokeApi(requestObj);
};

export const get_school_overview_api = async (school_id) => {
  const requestObj = {
    path: `api/school/overview/${school_id}`,
    method: "GET",
    headers: getAuthHeader(),
  };
  return invokeApi(requestObj);
};
